import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-[#0a0a0a] py-32 px-4 relative overflow-hidden" data-id="element-35">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(168,85,247,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-36"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-37">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight" data-id="element-38">
          🚀 La inteligencia artificial no es el futuro
        </h2>
        <h3 className="text-4xl md:text-5xl font-bold text-[#FFD700] mb-12" data-id="element-39">
          Es el presente.
        </h3>

        <p className="text-2xl text-white mb-8" data-id="element-40">
          Y en los próximos años habrá dos tipos de personas:
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-16" data-id="element-41">
          <div className="bg-red-950/30 border border-red-900/50 p-6 rounded-xl flex items-center gap-4" data-id="element-42">
            <span className="text-3xl" data-id="element-43">❌</span>
            <span className="text-xl text-white font-medium" data-id="element-44">
              quienes nunca aprendieron a usarla
            </span>
          </div>
          <div className="bg-green-950/30 border border-green-900/50 p-6 rounded-xl flex items-center gap-4" data-id="element-45">
            <span className="text-3xl" data-id="element-46">✅</span>
            <span className="text-xl text-white font-medium" data-id="element-47">
              quienes aprovecharon la oportunidad
            </span>
          </div>
        </div>

        <div className="mb-12" data-id="element-48">
          <p className="text-3xl font-bold text-white mb-6" data-id="element-49">👉 Accedé ahora</p>
          <div className="flex flex-wrap justify-center gap-4 text-lg text-[#c4b5d4] font-medium" data-id="element-50">
            <span className="bg-white/5 px-4 py-2 rounded-full border border-white/10" data-id="element-51">
              🎓 Curso Dominá la Inteligencia Artificial
            </span>
            <span className="bg-white/5 px-4 py-2 rounded-full border border-white/10" data-id="element-52">
              🎁 3 Bonos incluidos
            </span>
            <span className="bg-white/5 px-4 py-2 rounded-full border border-white/10" data-id="element-53">
              🔓 Acceso inmediato
            </span>
          </div>
        </div>

        <CTAButton data-id="element-54">COMPRAR AHORA</CTAButton>
      </div>
    </section>;
}